import type { Messages } from '../catalogue.en'

export const imaging: Partial<Messages> = {
  'imaging.title': 'הדמיה',
  'imaging.subtitle': 'מחקרי CT ו-MRI מאוחסנים הזמינים לצוות המטפל של המטופל.',
  'imaging.tableLabel': 'מחקרי ההדמיה של המטופל',
  'imaging.add': 'הוספת מחקר הדמיה',
  'imaging.folder': 'תיקייה',
  'imaging.folderUnfiled': 'ללא תיקייה',
  'imaging.forbidden': 'מחקרי הדמיה אינם זמינים לחשבון זה',
  'imaging.forbiddenDetail': 'המרפאה לא העניקה גישה להדמיה המאוחסנת.',
  'imaging.movedTitle': 'הדימות נמצא בקבצי המטופל',
  'imaging.movedDetail': 'בדיקות וייבוא מופיעים כשורות בטבלת הקבצים. סננו את עמודת התוכן לפי «דימות רפואי» כדי לראות אותן בנפרד.',
  'imaging.loading': 'טוען מחקרי הדמיה…',
  'imaging.loadFailed': 'לא ניתן לטעון את מחקרי ההדמיה.',
  'imaging.retry': 'נסה שוב',
  'imaging.empty': 'אין מחקרי הדמיה מאוחסנים',
  'imaging.emptyDetail': 'מחקרי CT ו-MRI מאומתים שיובאו עבור מטופל זה יופיעו כאן.',
  'imaging.noMatches': 'אין מחקר הדמיה התואם למסננים הנוכחיים',
  'imaging.columnStudy': 'מחקר',
  'imaging.columnDate': 'תאריך המחקר',
  'imaging.columnModality': 'סוג',
  'imaging.columnSeries': 'סדרות',
  'imaging.columnImages': 'תמונות',
  'imaging.columnSource': 'מקור',
  'imaging.columnStatus': 'סטטוס',
  'imaging.columnActions': 'פעולות',
  'imaging.studyUntitled': 'מחקר הדמיה',
  'imaging.viewerOpen': 'פתיחת מציג',
  'imaging.viewerOpenNamed': 'פתיחת מציג עבור {name}',
  'imaging.viewerOpening': 'פותח מציג…',
  'imaging.viewerUnavailable': 'לא ניתן לפתוח את המציג. נסה שוב.',
  'imaging.viewerContinue': 'המשך למציג',
  'imaging.viewerPopupBlocked': 'הדפדפן חסם את לשונית המציג החדשה. המשך באמצעות קישור זה.',
  'imaging.viewerPending': 'ממתין לאימות הארכיון',
  'imaging.statusWithdrawn': 'הוסרה — נרשמה בטעות',

  'imaging.studyPanelTitle': 'מאפייני בדיקת הדימות',
  'imaging.studyStorage': 'אחסון ושמירה',
  'imaging.studyRetention': 'מדיניות שמירה',
  'imaging.retentionIndefinite': 'נשמר עד למחיקה',
  'imaging.retentionUntil': 'נשמר עד {date}',
  'imaging.studyRegistered': 'נרשם',
  'imaging.studyIdentifier': 'מזהה UID של הדימות',
  'imaging.purgeLabel': 'מחיקה',
  'imaging.purge.queued': 'ממתין למחיקה לצמיתות',
  'imaging.purge.purged': 'נמחק לצמיתות',
  'imaging.purge.failed': 'המחיקה לצמיתות נכשלה',

  'imaging.studyComment': 'הערה',
  'imaging.noComment': 'לא נרשמה הערה',
  'imaging.editMetadata': 'עריכת הפרטים',
  'imaging.editFormLabel': 'עריכת הפרטים עבור {name}',
  'imaging.editTitle': 'כותרת',
  'imaging.editTitleHint': 'השאר ריק כדי להציג את התיאור שסיפק הארכיון.',
  'imaging.editComment': 'הערה',
  'imaging.editSave': 'שמירת הפרטים',
  'imaging.editSaving': 'שומר',
  'imaging.editCancel': 'ביטול',
  'imaging.editStaleRevision': 'מישהו אחר שינה את הפרטים האלה בזמן שערכת אותם.',
  'imaging.editStaleRevisionDetail':
    'טען את הגרסה השמורה כדי לראות מה מאוחסן כעת, ולאחר מכן החל עליה את השינוי שלך.',
  'imaging.editReload': 'טעינת הגרסה השמורה',
  'imaging.editReloadFailed': 'לא ניתן היה לטעון את הגרסה השמורה. השינויים שלך עדיין כאן.',
  'imaging.editInvalid': 'בדוק את הפרטים ונסה שוב.',
  'imaging.editForbidden': 'אין לך הרשאה לערוך את בדיקת הדימות הזאת.',
  'imaging.editGone': 'בדיקת הדימות הזאת אינה זמינה עוד.',
  'imaging.editSessionEnded': 'ההפעלה שלך הסתיימה. היכנס שוב כדי להמשיך.',
  'imaging.editUnavailable': 'לא ניתן היה לשמור את הפרטים כעת. נסה שוב מאוחר יותר.',
  'imaging.editUnsavedTitle': 'פרטים שלא נשמרו',
  'imaging.editUnsavedDetail': 'שינית את הפרטים של בדיקת הדימות הזאת ולא שמרת אותם.',
  'imaging.editKeepEditing': 'המשך עריכה',
  'imaging.editDiscard': 'ביטול השינויים',
  'imaging.unsavedIntent': 'פרטי בדיקת דימות',

  'imaging.linkUnknownRecord': 'רשומה',
  'imaging.linksTitle': 'רשומות רפואיות',
  'imaging.linksNone': 'אין רשומות רפואיות המקושרות לבדיקה זו.',
  'imaging.linksAdd': 'הוספת רשומה רפואית',
  'imaging.linkPick': 'קישור לרשומה…',
  'imaging.linksUnavailable': 'קישורי הרשומות של בדיקת הדימות הזאת אינם זמינים.',
  'imaging.linkedAt': 'קושר {date}',
  'imaging.unlinkAction': 'ביטול קישור',
  'imaging.unlinkRecord': 'ביטול הקישור אל {name}',
  'imaging.linkWorking': 'מבצע',
  'imaging.linkAddTitle': 'קישור לרשומה',
  'imaging.linkRecordsLoading': 'טוען רשומות',
  'imaging.linkRecordsUnavailable': 'רשימת הרשומות אינה זמינה',
  'imaging.linkNoneOnThisPage': 'אין רשומות נוספות בעמוד הזה. הצג רשומות ישנות יותר כדי למצוא עוד.',
  'imaging.linkNoneAvailable': 'למטופל זה אין רשומות סופיות נוספות לקישור.',
  'imaging.linkAction': 'קישור',
  'imaging.linkRecord': 'קישור אל {name}',
  'imaging.recordFinalizedAt': 'הופק סופית',
  'imaging.recordStatusFinal': 'סופית',
  'imaging.linkMoreRecords': 'הצגת רשומות ישנות יותר',
  'imaging.linkForbidden': 'אין לך הרשאה לשנות קישורי רשומות עבור בדיקת הדימות הזאת.',
  'imaging.linkGone': 'לא ניתן היה לשנות את הקישור. בדיקת הדימות או הרשומה אינם זמינים עוד.',
  'imaging.linkUnavailable': 'לא ניתן היה לשנות את קישור הרשומה כעת. נסה שוב מאוחר יותר.',

  'imaging.exportReadingInventory': 'קוראים את נתוני המחקר',
  'imaging.exportReadingSources': 'קוראים את אובייקטי המקור שנבחרו',
  'imaging.exportRendering': 'מקודדים אובייקטי DICOM',
  'imaging.exportPackaging': 'מכינים את ארכיון ZIP ואת אינדקס המדיה',
  'imaging.exportUploading': 'שומרים את ארכיון הייצוא',
  'imaging.exportMetadataCount': 'נקראו נתונים של {count} אובייקטים בסדרה זו',
  'imaging.exportObjectCount': 'אובייקטי DICOM שהוכנו: {count}',
  'imaging.exportCancelPreparationHint': 'הביטול יושלם לאחר שהשרת יסיים לבדוק את הבחירה. הייצוא לא יישאר בתור.',
  'imaging.exportTitle': 'ייצוא בדיקת DICOM',
  'imaging.exportSubtitle': 'בחרו סדרות, טווחי מסגרות, חיתוך וקידוד המתאימים למציג הלא־מקוון של הרופא המקבל.',
  'imaging.exportLoading': 'קוראים את רשימת הסדרות והמסגרות…',
  'imaging.exportInventoryFailed': 'לא ניתן לקרוא את תוכן מחקר ההדמיה לייצוא. סגרו את החלונית ונסו שוב.',
  'imaging.exportForbidden': 'אין לך הרשאה לייצא בדיקת דימות זו.',
  'imaging.exportStudyUnavailable': 'בדיקת דימות זו אינה זמינה עוד לייצוא.',
  'imaging.exportSourceChanged': 'מחקר ההדמיה השתנה לאחר טעינת האפשרויות. יש לסגור את החלונית ולפתוח שוב את הייצוא.',
  'imaging.exportEmpty': 'במחקר ההדמיה אין סדרות תמונה נתמכות מסוג CT או MR לייצוא.',
  'imaging.exportFormat': 'פורמט פלט',
  'imaging.exportTransferSyntax': 'תחביר העברה',
  'imaging.exportTransferSyntaxHint': 'בחרו קידוד שנתמך במציג הלא־מקוון של הרופא המקבל.',
  'imaging.exportLossyQuality': 'איכות JPEG‏ (1–100)',
  'imaging.exportLayout': 'מבנה אובייקטי DICOM',
  'imaging.exportLayoutSource': 'שמירת מבנה המקור',
  'imaging.exportLayoutClassic': 'קלאסי — מופע אחד לכל מסגרת',
  'imaging.exportLayoutEnhanced': 'משופר — ריבוי מסגרות',
  'imaging.exportDicomdir': 'הוספת אינדקס מדיה DICOMDIR',
  'imaging.exportSeries': 'סדרות ומסגרות',
  'imaging.exportSeriesSelected': 'נבחרו: {count}',
  'imaging.exportSelectAll': 'בחירת הכול',
  'imaging.exportSelectNone': 'ביטול הבחירה',
  'imaging.exportSeriesFacts': '{modality} · {count} מיקומים מסודרים',
  'imaging.exportSourceObjects': 'אובייקטי מקור',
  'imaging.exportPixelMatrix': 'מטריצת פיקסלים',
  'imaging.exportPixelMatrixValue': '{rows} × {columns}',
  'imaging.exportStoredLayout': 'מבנה מאוחסן',
  'imaging.exportSourceClassic': 'מופעים קלאסיים',
  'imaging.exportSourceMultiframe': 'מופע מרובה מסגרות',
  'imaging.exportSourceState': 'מצב המקור',
  'imaging.exportSourceOriginal': 'מקורי',
  'imaging.exportSourceDerived': 'נגזר כבר',
  'imaging.exportSpacing': 'מרווח בין מישורים',
  'imaging.exportSpacingRegular': 'אחיד',
  'imaging.exportSpacingIrregular': 'לא אחיד',
  'imaging.exportSpacingUnknown': 'לא ידוע',
  'imaging.exportInterPlaneStep': 'צעד בין מישורים',
  'imaging.exportMillimetres': '{value} מ״מ',
  'imaging.exportSopClasses': 'מחלקות SOP',
  'imaging.exportStoredSyntaxes': 'תחבירי העברה מאוחסנים',
  'imaging.exportStack': 'מחסנית מרחבית',
  'imaging.exportStackOption': '{id} · {count} מיקומים',
  'imaging.exportStackDimension': '{label}: {value}',
  'imaging.exportDimensionStack': 'מחסנית',
  'imaging.exportDimensionTemporal': 'מיקום בזמן',
  'imaging.exportDimensionEchoNumber': 'מספר הד',
  'imaging.exportDimensionEchoTime': 'זמן הד',
  'imaging.exportDimensionDiffusionBValue': 'ערך b של דיפוזיה',
  'imaging.exportSelection': 'בחירת מיקומים',
  'imaging.exportSelectionRange': 'טווח וצעד',
  'imaging.exportSelectionExact': 'מיקומים מדויקים',
  'imaging.exportFirst': 'ראשון',
  'imaging.exportLast': 'אחרון',
  'imaging.exportStep': 'צעד',
  'imaging.exportRangeHint': 'טווח כולל במספור שמתחיל ב־1 ובסדר המרחבי של המטופל; צעד 2 בוחר כל מיקום שני.',
  'imaging.exportExactPositions': 'מיקומים',
  'imaging.exportExactPositionsPlaceholder': '451, 453, 457',
  'imaging.exportExactPositionsHint': 'יש להזין מספרי מיקום עולים, מופרדים בפסיקים או ברווחים (1–{count}).',
  'imaging.exportRangeUnavailable': 'הסדר המרחבי אינו זמין, ולכן ניתן לייצא את הסדרה רק במלואה.',
  'imaging.exportCrop': 'חיתוך מרחבי',
  'imaging.exportCropNone': 'ללא חיתוך',
  'imaging.exportCropPixel': 'מלבן בפיקסלים',
  'imaging.exportCropPatient': 'תיבה במרחב המטופל (מ״מ)',
  'imaging.exportLeft': 'שמאל',
  'imaging.exportTop': 'עליון',
  'imaging.exportWidth': 'רוחב',
  'imaging.exportHeight': 'גובה',
  'imaging.exportAxisMinimum': 'מינימום {axis}',
  'imaging.exportAxisMaximum': 'מקסימום {axis}',
  'imaging.exportSegmentationRoi': 'אזור עניין לפי סגמנטציה',
  'imaging.exportSegmentationNone': 'ללא החלת סגמנטציה',
  'imaging.exportSegmentationOption': '{number} · {name}',
  'imaging.exportSegmentationMode': 'מסכת סגמנטציה',
  'imaging.exportSegmentationInclude': 'שמירת פיקסלים בתוך הסגמנטציה',
  'imaging.exportSegmentationExclude': 'הסרת פיקסלים בתוך הסגמנטציה',
  'imaging.exportInvalid': 'בחרו לפחות סדרה אחת ובדקו את כל ערכי הבחירה והחיתוך.',
  'imaging.exportSelectionInvalid': 'בחרו סדרה ומחסנית מרחבית זמינה. ודאו שהמיקומים שנבחרו נמצאים בטווח שלה.',
  'imaging.exportRangeInvalid': 'המיקום הראשון, המיקום האחרון והצעד חייבים להיות מספרים שלמים חיוביים. הראשון לא יעלה על האחרון, והאחרון לא יעלה על מספר המיקומים הזמינים.',
  'imaging.exportExactInvalid': 'הזינו מספרי מיקומים זמינים בסדר עולה, ללא כפילויות, מופרדים ברווחים או בפסיקים.',
  'imaging.exportPixelInvalid': 'אזור החיתוך חייב להיות בתוך מטריצת התמונה. ההיסטים משמאל ומלמעלה חייבים להיות מספרים שלמים שאינם שליליים, והרוחב והגובה חייבים להיות מספרים שלמים חיוביים.',
  'imaging.exportPatientInvalid': 'הזינו את כל שש הקואורדינטות במילימטרים. המינימום בכל ציר חייב להיות קטן מהמקסימום.',
  'imaging.exportQualityInvalid': 'איכות JPEG Baseline חייבת להיות מספר שלם מ־1 עד 100. קידודים אחרים אינם משתמשים בהגדרה זו.',
  'imaging.exportDicomdirFailed': 'לא ניתן ליצור אינדקס מדיה DICOMDIR מנתוני הכותרות של התמונות. בטלו את הכללת אינדקס DICOMDIR וייצאו שוב. אם התוכנה המקבלת דורשת DICOMDIR, בקשו מהתמיכה לבדוק את נתוני המקור.',
  'imaging.exportCropEmpty': 'אזור החיתוך אינו תקין או אינו חופף לתמונות שנבחרו. בדקו את הגבולות; לחיתוך במרחב המטופל, בחרו את כל טווח המיקומים כדי שהתיבה תקבע את המסגרות.',
  'imaging.exportEncodingFailed': 'הקידוד שנבחר אינו מתאים לפיקסלים או לשינוי המבוקש. בחרו ללא דחיסה — Explicit VR Little Endian — ונסו שוב.',
  'imaging.exportDecodeFailed': 'לא ניתן לפענח את פיקסלי המקור. נסו לייצא את אובייקטי המקור בשלמותם כפי שנשמרו, או בקשו מהתמיכה לבדוק את קובץ המקור.',
  'imaging.exportGeometryFailed': 'במקור חסרה גאומטריה אמינה במרחב המטופל לפעולה זו. ייצאו את הסדרה בשלמותה במבנה המקור, ללא חיתוך או מסכת סגמנטציה.',
  'imaging.exportLayoutFailed': 'מבנה האובייקטים שנבחר אינו מתאים לתמונות. שמרו על מבנה המקור, בחרו ללא דחיסה — Explicit VR Little Endian — או ייצאו סדרות שאינן תואמות בנפרד.',
  'imaging.exportSegmentationFailed': 'הסגמנטציה אינה מיושרת לתמונות שנבחרו. הסירו את המסכה או בחרו סגמנטציה מאותה מערכת ייחוס.',
  'imaging.exportMediaFailed': 'החבילה שנוצרה נכשלה בבדיקת תקינות. צרו את הייצוא שוב; אם הוא נכשל שוב, בקשו מהתמיכה לבדוק את קובץ המקור. תמונות המקור לא שונו.',
  'imaging.exportAsStoredUnavailable': 'ייצוא כפי שנשמר אינו זמין בעת שינוי המבנה, חילוץ חלק מאובייקט מרובה מסגרות, חיתוך או החלת מסכה. נעשה שימוש בקידוד לפלט שנוצר.',
  'imaging.exportJpegUnavailable': 'JPEG Baseline אינו זמין לפיקסלים אלה: נדרשות תמונות של 8 סיביות ללא סימן. בחרו קידוד זמין ללא אובדן לשמירת ערכי הפיקסלים המקוריים.',
  'imaging.exportPatientCropHint': 'הקואורדינטות הן במרחב המטופל. השאירו את טווח המיקומים המלא כדי שהתיבה תבחר את המסגרות. מיקומי הייצוא מסודרים במרחב המטופל ועשויים להיות שונים ממספרי המסגרות בתוכנת הצפייה.',
  'imaging.exportAction': 'ייצוא',
  'imaging.exportStarting': 'מתחילים ייצוא…',
  'imaging.exportQueued': 'הייצוא בתור',
  'imaging.exportRunning': 'יוצרים חבילת DICOM',
  'imaging.exportRunningHint': 'השרת יוצר ומאמת את האובייקטים שנבחרו. אפשר לסגור את החלונית בבטחה.',
  'imaging.exportCancel': 'ביטול הייצוא',
  'imaging.exportCancelling': 'מבטלים…',
  'imaging.exportReady': 'חבילת ה־DICOM הזמנית מוכנה להורדה.',
  'imaging.exportDownload': 'הורדת הייצוא',
  'imaging.exportFailed': 'לא ניתן ליצור את חבילת ה־DICOM. נסו שוב ללא דחיסה — Explicit VR Little Endian; אם הפעולה נכשלת שוב, בקשו מהתמיכה לבדוק את הייצוא. תמונות המקור לא שונו.',
  'imaging.exportCancelled': 'הייצוא בוטל והנתונים הזמניים מוסרים.',
  'imaging.exportExpired': 'תוקף הייצוא הזמני פג. צרו אותו מחדש מתוך מחקר ההדמיה.',
  'imaging.exportStatusFailed': 'לא ניתן לרענן את מצב הייצוא. המשימה בשרת לא השתנתה.',
  'imaging.exportCreateFailed': 'לא ניתן להתחיל את הייצוא. בדקו את הפרמטרים ונסו שוב.',
  'imaging.exportCancelFailed': 'לא ניתן לבטל את הייצוא. מצבו הנוכחי בשרת לא השתנה.',
  'imaging.exportTsAsStored': 'כפי שנשמר — ללא קידוד מחדש',
  'imaging.exportTsImplicit': 'ללא דחיסה — Implicit VR Little Endian',
  'imaging.exportTsExplicit': 'ללא דחיסה — Explicit VR Little Endian',
  'imaging.exportTsJpegBaseline': 'JPEG Baseline — מאבד מידע, 8 סיביות',
  'imaging.exportTsJpegLossless': 'JPEG ללא אובדן SV1',
  'imaging.exportTsJpegLs': 'JPEG-LS ללא אובדן',
  'imaging.exportTsJpeg2000': 'JPEG 2000 ללא אובדן',
  'imaging.exportTsRle': 'RLE ללא אובדן',

  'imaging.importTitle': 'הוספת מחקר הדמיה',
  'imaging.importSubtitle': 'בחר את מקור המחקר. השורה שלו תופיע בטבלה מיד, ו-Terysling מאמתת את המקור לפני שדבר נעשה זמין בתיק המטופל.',
  'imaging.sourceLegend': 'מקור ההדמיה',
  'imaging.sourceArchive': 'העלאת ארכיונים',
  'imaging.sourceArchiveDetail': 'חבילות ZIP שסיפק המטופל או מכון ההדמיה. בחר כמה מהן, וכל אחת מיובאת בנפרד.',
  'imaging.sourceFiles': 'בחירת תיקייה או קבצים',
  'imaging.sourceFilesDetail': 'תוכן שהועתק ממדיה רפואית, מיובא כמקור אחד; תוכנות מציג מצורפות אינן מופעלות.',
  'imaging.sourceRemote': 'ייבוא מקישור',
  'imaging.sourceRemoteDetail': 'Terysling מורידה חבילת הדמיה שניתנת לייבוא דרך HTTPS.',
  'imaging.kindArchive': 'ארכיון ZIP',
  'imaging.kindFiles': 'תיקייה או קבצים',
  'imaging.kindRemote': 'קישור להורדה',
  'imaging.chooseArchive': 'בחירת ארכיוני ZIP',
  'imaging.chooseMoreArchives': 'הוספת ארכיונים נוספים',
  'imaging.chooseFolder': 'בחירת תיקייה',
  'imaging.chooseFiles': 'בחירת קבצים',
  'imaging.chosenOne': 'נבחר קובץ אחד',
  'imaging.chosenMany': 'נבחרו {count} קבצים',
  'imaging.chosenBytes': '{size} בסך הכול',
  'imaging.chosenMore': 'אינם מופיעים ברשימה: {count}',
  'imaging.removeChosen': 'הסרת {name}',
  'imaging.fileSetLabel': 'הקבצים שנבחרו',
  'imaging.invalidArchive': 'בחר ארכיוני ZIP שאינם ריקים ובגבולות הגודל הנתמכים.',
  'imaging.invalidFiles': 'בחר בין קובץ אחד ל-100,000 קבצים שאינם ריקים ובגבולות הגודל הנתמכים.',
  'imaging.remoteUrl': 'קישור להורדה',
  'imaging.remoteUrlPlaceholder': 'https://imaging-centre.example/download',
  'imaging.remotePassword': 'סיסמה או קוד גישה (לא חובה)',
  'imaging.remotePasswordHint': 'הסוד נשלח פעם אחת עבור הייבוא ואינו מוצג שוב.',
  'imaging.invalidRemoteUrl': 'הזן קישור HTTPS תקין ללא שם משתמש או סיסמה בתוך הכתובת.',
  'imaging.startImportOne': 'התחלת ייבוא',
  'imaging.startImportMany': 'התחלת ייבואים: {count}',

  'imaging.phase.starting': 'מתחיל…',
  'imaging.phase.transferring': 'בהעברה',
  'imaging.phase.checking': 'באימות',
  'imaging.phase.review': 'מוכן לשמירה',
  'imaging.phase.saving': 'בשמירה',
  'imaging.phase.interrupted': 'ההעברה נקטעה',
  'imaging.phase.refused': 'הייבוא נדחה',
  'imaging.transportProgress': '{percent}% הועברו',
  'imaging.transportRetry': 'המשך העלאה',
  'imaging.transportRetryNamed': 'המשך ההעלאה של {name}',
  'imaging.transportRetrying': 'ממשיך…',
  'imaging.reselectSource': 'בחירה מחדש של המקור',
  'imaging.reselectSourceNamed': 'בחירה מחדש של קובצי המקור עבור {name}',
  'imaging.restartImport': 'להתחיל מחדש',
  'imaging.restartImportNamed': 'להתחיל מחדש את הייבוא של {name}',
  'imaging.restartRemoteTitle': 'להוריד את המקור שוב?',
  'imaging.restartRemoteDetail': 'Terysling שומר את הכתובת ולא את ההורדה, ולכן פעולה זו פותחת ייבוא חדש מאותה כתובת ומבטלת את הייבוא שנדחה. הסיסמה נדרשת שוב משום שהיא נמסרה פעם אחת ואינה נשמרת בדפדפן הזה.',
  'imaging.restartRemoteKeep': 'להשאיר את הייבוא שנדחה',
  'imaging.importRefreshFailed': 'לא ניתן לרענן את מצב הייבוא. הייבוא עדיין נשמר ב-Terysling.',
  'imaging.uploadLedgerFailed': 'לא ניתן היה לרענן את רשימת ההעלאות. השורות הקיימות נשארות גלויות.',
  'imaging.saveStudy': 'שמירת המחקר',
  'imaging.saveStudyNamed': 'שמירת {name}',
  'imaging.cancelUploadNamed': 'ביטול ההעלאה של {name}',
  'imaging.cancelUploadTitle': 'לבטל את ההעלאה?',
  'imaging.cancelUploadDetail': 'ההעלאה תיעצר, ההרשאה תבוטל, המקום השמור ישוחרר והנתונים הזמניים יועברו למחיקה. לאחר מכן השורה תוסר מכל רשימות ההעלאה.',
  'imaging.cancelUploadKeep': 'להמשיך בהעלאה',
  'imaging.cancelUploadConfirm': 'ביטול ההעלאה',
  'imaging.cancelUploadFailed': 'לא ניתן היה לבטל את ההעלאה. היא נשארת גלויה ולא הוסתרה עבודה.',
  'imaging.uploadsUnfinished': 'העלאות שלא הושלמו: {continuing} ממשיכות, {paused} ממתינות לבחירה מחדש של המקור, {confirmation} ממתינות לאישור, {refused} נדחו.',
  'imaging.uploadsUnfinishedDismiss': 'סגירה',

  'imaging.detectedCountOne': 'זוהה מחקר אחד',
  'imaging.detectedCountMany': 'זוהו {count} מחקרים',
  'imaging.previewTitle': 'סקירת המחקרים שזוהו',
  'imaging.previewDetail': 'זהות DICOM שלהלן היא ראיית מקור בלבד. היא לעולם אינה משנה את המטופל שנבחר ב-Terysling.',
  'imaging.targetPatient': 'מטופל היעד ב-Terysling',
  'imaging.sourcePatient': 'פרטי המטופל ב-DICOM',
  'imaging.identityComparison': 'השוואת פרטי המטופל',
  'imaging.patientName': 'שם',
  'imaging.patientId': 'מזהה מטופל',
  'imaging.patientBirthDate': 'תאריך לידה',
  'imaging.patientSex': 'מין',
  'imaging.notRecorded': 'לא תועד',
  'imaging.studySelect': 'ייבוא {name}',
  'imaging.studyDescription': 'תיאור',
  'imaging.studyBodyPart': 'אזור גוף',
  'imaging.studySource': 'ארגון מקור',
  'imaging.studyDate': 'תאריך המחקר',
  'imaging.studySeries': 'סדרות',
  'imaging.studyImages': 'תמונות',
  'imaging.demographicMismatchTitle': 'פרטי המטופל אינם תואמים',
  'imaging.demographicMismatchDetail': 'בדוק היטב את שתי הזהויות. ייבא רק אם המחקר שייך למטופל שנבחר.',
  'imaging.demographicMismatchConfirm': 'וידאתי שהמחקרים שנבחרו שייכים למטופל זה',
  'imaging.confirm': 'שמירת המחקרים שנבחרו',
  'imaging.confirming': 'שומר…',
  'imaging.confirmSelectionRequired': 'בחר לפחות מחקר נתמך אחד.',
  'imaging.confirmMismatchRequired': 'אמת את אי-ההתאמה בפרטי המטופל לפני הייבוא.',
  'imaging.confirmFailed': 'לא ניתן היה לאשר את הייבוא. התצוגה המקדימה רועננה — יש לבדוק אותה ולנסות שוב.',
  'imaging.confirmStale': 'התצוגה המקדימה השתנתה בזמן שהחלונית הייתה פתוחה וזה עתה רועננה. יש לבדוק מה מסומן עכשיו ולשמור שוב.',
  'imaging.confirmNotConfirmable': 'הייבוא כבר אינו ממתין לאישור — הוא כבר נשמר, בוטל או נדחה. התצוגה המקדימה המרועננת מראה מה מהם.',
  'imaging.confirmSelectionRefused': 'המחקרים שנבחרו נדחו. התצוגה המקדימה רועננה; יש לבחור מתוך המחקרים שהיא מציגה עכשיו.',
  'imaging.confirmQuota': 'שמירת המחקרים האלה תחרוג משטח האחסון של המרפאה לתמונות. יש לשמור פחות מחקרים או לפנות מקום קודם.',
  'imaging.confirmMismatchRefused': 'בייבוא קיימת אי-התאמה בפרטי המטופל שהתצוגה המקדימה לא הראתה. היא רועננה — יש לקרוא שוב את ההשוואה ולאשר את אי-ההתאמה.',
  'imaging.confirmForbidden': 'לחשבון הזה אין הרשאה לשמור מחקרי דימות. דבר לא נשמר.',
  'imaging.confirmGone': 'הייבוא כבר אינו זמין. דבר לא נשמר.',
  'imaging.confirmUnavailable': 'אחסון הדימות לא הגיב. דבר לא נשמר, וכדאי לנסות שוב.',
  'imaging.dicomUidCollision': 'מחקר זה כבר משויך למטופל {displayName} ({patientCode}).',

  'imaging.deleteSelected': 'מחיקת הנבחרים: {count}',
  'imaging.aiUnavailableForStudies':
    'כלי ה-AI עדיין אינם קוראים בדיקות דימות. עיבוד כולל רק את המסמכים שנבחרו.',
  'imaging.deleteTitle': 'למחוק את פריטי ההדמיה שנבחרו?',
  'imaging.deleteStudiesTitle': 'מחקרים מאוחסנים, נמחקים לצמיתות',
  'imaging.deleteStudiesDetail': 'הגישה למציג תבוטל והארכיון ייכנס לתור למחיקה לצמיתות. לא ניתן לבטל פעולה זו.',
  'imaging.deleteQueuedTitle': 'ייבואים בתהליך, מבוטלים בכל היישום',
  'imaging.deleteQueuedDetail': 'ההעברה והעיבוד ייעצרו, הרשאת ההעלאה תבוטל, המקום השמור ישוחרר והנתונים הזמניים יועברו למחיקה.',
  'imaging.deleteKeep': 'להשאיר',
  'imaging.deleteConfirm': 'מחיקה',
  'imaging.deleting': 'מוחק…',
  'imaging.deleteFailed': 'לא ניתן היה להשלים את המחיקה. מלבד המחקרים שכבר הוסרו לא נמחק דבר.',

  'imaging.compatibility.pending': 'בדיקת התאימות ממתינה',
  'imaging.compatibility.supported': 'נתמך',
  'imaging.compatibility.warning': 'נתמך עם אזהרה',
  'imaging.compatibility.unsupported': 'לא נתמך',
  'imaging.issue.unsupportedModality': 'אובייקטים מסוגי סריקה שאינם נתמכים דולגו.',
  'imaging.issue.unsupportedSopClass': 'סוגי אובייקט DICOM שאינם נתמכים דולגו.',
  'imaging.issue.unsupportedTransferSyntax': 'תמונות בקידוד שאינו נתמך דולגו.',
  'imaging.issue.unsupportedMultiframe': 'אובייקטים מרובי מסגרות שאינם נתמכים דולגו.',
  'imaging.issue.nonDicomFilesIgnored': 'קבצים שאינם DICOM הושמטו.',
  'imaging.issue.encryptedArchiveUnsupported': 'לא ניתן לייבא ארכיוני ZIP המוגנים בסיסמה.',
  'imaging.issue.burnedInAnnotation': 'ייתכן שהתמונות מכילות טקסט מטופל שצויר בתוך הפיקסלים.',
  'imaging.issue.lossyCompression': 'המקור מכיל תמונות בדחיסה מאבדת.',
  'imaging.issue.demographicMismatch': 'פרטי המטופל במקור שונים מהמטופל שנבחר.',
  'imaging.issue.other': 'המאמת דיווח על אזהרת תאימות.',
  'imaging.issueWithCount': '{issue} ({count})',
  'imaging.failure.remoteNotImportable': 'קישור זה פותח מציג אינטרנט אך אינו חושף חבילת הדמיה להורדה.',
  'imaging.failure.remoteForbidden': 'יעד הקישור אינו מותר לייבוא מרוחק מאובטח.',
  'imaging.failure.remoteUnavailable': 'המקור המרוחק נשאר לא זמין לאחר ניסיונות חוזרים. בדוק את הקישור ואת זמינות המקור ולאחר מכן התחל את הייבוא מחדש.',
  'imaging.failure.unsafeArchive': 'הארכיון נדחה מפני שהמבנה או הגודל המורחב שלו אינם בטוחים.',
  'imaging.failure.encryptedArchiveUnsupported': 'לא ניתן לייבא ארכיוני ZIP המוגנים בסיסמה. הסר את הסיסמה ונסה שוב.',
  'imaging.failure.noDicom': 'לא נמצא מחקר DICOM קריא במקור שסופק.',
  'imaging.failure.mixedIdentity': 'המקור מכיל יותר מזהות מטופל אחת ולא ניתן לייבא אותן יחד.',
  'imaging.failure.unsupportedDicom': 'המחקר שנבחר מחוץ לחוזה התאימות הנתמך של DICOM.',
  'imaging.failure.duplicateImages': 'המקור מכיל מזהי תמונה כפולים.',
  'imaging.failure.inconsistentSeries': 'המקור מכיל מטא־נתונים לא עקביים של סדרה ולא ניתן לייבא אותו בבטחה.',
  'imaging.failure.tooLarge': 'המקור חורג ממגבלות ייבוא ההדמיה שהוגדרו.',
  'imaging.failure.generic': 'לא ניתן היה לייבא את מקור ההדמיה. נסה שוב או בקש ממנהל לבדוק את השירות.',
}
